#import "../list/TravelSectionAuthDataFragment.graphql"

mutation TravelAuthorizationUpdate($input: TravelAuthorizationUpdateInput!) {
  travelAuthorizationUpdate(input: $input) {
    travelAuthorization {
      __typename
      id
      stampedEntityDocumentId
      _rowTimestamp
      _isUpdatable
      _isDeletable
      _isOverBudget
      _isDistributionUpdateAllowed
      _isRevisable
      _isAccountingEntry
      _isHistory
      _isStampAllowed
      _isUnstampAllowed
      _isRevisable
      _isAccountingEntryStampedComplete
      _isTransactionCancelled
      _accountingStampDate
      _accountingStampUserName
      _accountingStampTransactionReference
      travelAuthorizationNumber
      _travelerReference
      _isPlanningPhase
      tripPurpose
      comment
      travelAuthorizationDate
      bookingFee
      departmentId
      currencyId
      _isTripMovementAllowed
      department {
        name
      }
      businessUnit {
        name
        _isProductionBusinessUnit
        _isCorporateWorkgroupRequired
      }
      corporateWorkgroupId
      currency {
        isoCode
        name
        currencySymbol
      }
      statusType {
        statusType
        approvalState
        _transactionIconStatus
      }
      _suppliers
      isPersonalTravelAuthorization
      businessUnitId
      supplierId

      supplier {
        id
        _fullName
        _isUpdatable
        _isApproved
        supplierAddressesBySupplierId(orderBy: IS_PRIMARY_DESC, first: 1) {
          nodes {
            isPrimary
            addressLine1
            addressLine2
            cityName
            postalCode
            stateRegion {
              stateRegion
              country {
                country
              }
              stateRegionDescription
            }
            telephoneNumber
            emailAddress
          }
        }
        vendorNumber
      }
      budgetAmount
      controlTotalAmount
      ...TravelAuthorizationTravelSectionFragment
      trips(orderBy:[TRAVELER_REFERENCE_NAME_ASC , TRIP_LOCATOR_ASC]) {
        nodes {
          id
          _rowTimestamp
          tripLocator
          travelerReferenceName
          accountReference
          airfareAmount
          accommodationAmount
          transportationAmount
          vehicleRentalAmount
          trainAmount
          otherAmount
          controlTotalAmount
          _isOverBudget
          budgetAmount
          travelAuthorization {
            currency {
              id
              isoCode
              currencySymbol
            }
          }
        }
      }
      _requiredApprovalDocuments
      _isProtected
      isDraft
      _isStagedApprovalRequest
      _isApprovalRevocable
      _isCloningAllowed
    }
  }
}
